(ns common.schema.entities.survey.survey-answer
  (:require
   [clojure.string :as string]
   [common.data-types :as dt]
   [common.date-formats :as date-formats]
   [common.entity-name :as entity-name]
   [common.schema.data-types :as data-types]
   [common.schema.schema-utils :as su]
   [common.timezones :as timezones]))

(def schema
  (concat
   (su/single-ref-field :survey-answer/question
                        "Question"
                        [:entity.type/survey-question]
                        {:authorization            su/access-sug-sug
                         :default-field-visibility :in-use-disabled})
   (su/text-edn-field :survey-answer/answer
                      "Answer"
                      {:authorization            su/access-sug-sug
                       :default-field-visibility :in-use-disabled})
   (su/option-field-multi :survey-answer/no-answer-category
                          "Reason for not answering"
                          {:authorization            su/access-sug-sug
                           :default-field-visibility :in-use-disabled})
   (su/text-multiline-field :survey-answer/no-answer-description
                            "Description for reason"
                            {:authorization            su/access-sug-sug
                             :default-field-visibility :in-use-disabled})
   (su/integer-field :survey-answer/answer-set-index
                     "Answer set index"
                     {:authorization            su/access-sug-sug
                      :default-field-visibility :in-use-disabled})
   (su/text-simple-field :survey-answer/answer-timeseries
                         "Answer set timeseries"
                         {:authorization            su/access-sug-sug
                          :default-field-visibility :in-use-disabled})
   (su/calculated-field :survey-answer/value-as-text
                        "Value as text"
                        {:default-field-visibility :in-use
                         :data-type                :data.type/text-simple
                         :composite-attrs          [:survey-answer/answer :survey-answer/question]
                         :calculation-triggers     {:entity.type/survey-question [[:survey-answer/_question]]}
                         :calc-fn                  (fn [{:keys [tr entity-data entity-lookup]}]
                                                     (let [data-type (some-> entity-data
                                                                             :survey-answer/question
                                                                             (entity-lookup)
                                                                             :survey-question/data-type)
                                                           value (dt/parse-edn-string (:survey-answer/answer entity-data))]
                                                       (cond (nil? value)
                                                             nil
                                                             (string? value)
                                                             value
                                                             (data-types/numeric-data-types data-type)
                                                             (if (= data-type :data.type/currency-value)
                                                               (pr-str (double value))
                                                               value)
                                                             (data-types/date-data-types data-type)
                                                             (date-formats/format-millis value "YYYY-MM-DDThh:mm:ssZ" timezones/default-timezone)
                                                             (data-types/ref-or-kw-types data-type)
                                                             (if (some #{data-type} [:data.type/keyword :data.type/keyword-multi])
                                                               (if (coll? value)
                                                                 (->> value
                                                                      (map tr)
                                                                      (string/join "; "))
                                                                 (tr value))
                                                               (if (coll? value)
                                                                 (->> value
                                                                      (keep (fn [id]
                                                                              (entity-lookup (cond (string? id)
                                                                                                   (dt/parse-edn-string id)
                                                                                                   (number? id)
                                                                                                   id
                                                                                                   :else
                                                                                                   nil))))
                                                                      (map (partial entity-name/entity-name entity-lookup tr))
                                                                      (string/join "; "))
                                                                 (->> value
                                                                      (entity-lookup)
                                                                      (entity-name/entity-name entity-lookup tr))))
                                                             :else
                                                             (str value))))})
   (su/calculated-field :survey-answer/value-as-date
                        "Value as date"
                        {:default-field-visibility :in-use
                         :data-type                :data.type/datetime
                         :composite-attrs          [:survey-answer/answer :survey-answer/question]
                         :calculation-triggers     {:entity.type/survey-question [[:survey-answer/_question]]}
                         :calc-fn                  (fn [{:keys [entity-data entity-lookup]}]
                                                     (let [data-type (some-> entity-data
                                                                             :survey-answer/question
                                                                             (entity-lookup)
                                                                             :survey-question/data-type)]
                                                       (when (data-types/date-data-types data-type)
                                                         (dt/parse-edn-string (:survey-answer/answer entity-data)))))})
   (su/calculated-field :survey-answer/value-as-number
                        "Value as number"
                        {:default-field-visibility :in-use
                         :data-type                :data.type/number
                         :composite-attrs          [:survey-answer/answer :survey-answer/question]
                         :calculation-triggers     {:entity.type/survey-question [[:survey-answer/_question]]}
                         :calc-fn                  (fn [{:keys [entity-data entity-lookup]}]
                                                     (let [question (entity-lookup (:survey-answer/question entity-data))
                                                           data-type (:survey-question/data-type question)
                                                           edn-value (:survey-answer/answer entity-data)
                                                           numeric? (data-types/numeric-data-types data-type)
                                                           numeric-value (when numeric?
                                                                           (dt/parse-edn-string edn-value))]
                                                       numeric-value))})
   (su/calculated-field :survey-answer/value-as-name
                        "Value as name"
                        {:default-field-visibility :in-use
                         :data-type                :data.type/text-simple
                         :composite-attrs          [:survey-answer/answer :survey-answer/question]
                         :calculation-triggers     {:entity.type/survey-question [[:survey-answer/_question]]}
                         :calc-fn                  (fn [{:keys [entity-data entity-lookup tr]}]
                                                     (let [data-type (some-> entity-data
                                                                             :survey-answer/question
                                                                             (entity-lookup)
                                                                             :survey-question/data-type)
                                                           value (dt/parse-edn-string (:survey-answer/answer entity-data))]
                                                       (when value
                                                         (when (data-types/ref-or-kw-types data-type)
                                                           (if (some #{data-type} [:data.type/keyword :data.type/keyword-multi])
                                                             (if (coll? value)
                                                               (->> value
                                                                    (map tr)
                                                                    (string/join "; "))
                                                               (tr value))
                                                             (if (coll? value)
                                                               (->> value
                                                                    (keep (fn [id]
                                                                            (entity-lookup (cond (string? id)
                                                                                                 (dt/parse-edn-string id)
                                                                                                 (number? id)
                                                                                                 id
                                                                                                 :else
                                                                                                 nil))))
                                                                    (map (fn [entity]
                                                                           (entity-name/entity-name entity-lookup tr entity)))
                                                                    (string/join "; "))
                                                               (->> (cond (string? value)
                                                                          (dt/parse-edn-string value)
                                                                          (number? value)
                                                                          value
                                                                          :else
                                                                          nil)
                                                                    (entity-lookup)
                                                                    (entity-name/entity-name entity-lookup tr))))))))})))
